/**
 * One-time migration of cluster-related settings stored in localStorage.
 *
 * Pre-migration shape (legacy):
 *   {
 *     clusterEnabled,
 *     clusterMinSize,
 *     clusterSensitivity,
 *     clusterGroupAllBelowZoom,
 *     clusterDisableAboveZoom,
 *     ...other settings
 *   }
 *
 * Post-migration shape (canonical):
 *   {
 *     clusterEnabled,
 *     clusterPreset,           // "detalle" | "operacion" | "vistaGlobal"
 *     ...other settings
 *   }
 *
 * Mapping uses `clusterSensitivity` as the only signal:
 *   ≤ 0.85  → "detalle"
 *   ≤ 1.20  → "operacion"
 *   >  1.20 → "vistaGlobal"
 *
 * Idempotent: if `clusterPreset` is already set, returns input unchanged.
 *
 * @param {object} stored
 * @returns {object} migrated settings (legacy keys stripped)
 */
export function migrateClusterSettings(stored) {
  if (stored && stored.clusterPreset) return stored;

  const s = stored?.clusterSensitivity ?? 1.0;
  let preset;
  if (s <= 0.85) preset = "detalle";
  else if (s <= 1.20) preset = "operacion";
  else preset = "vistaGlobal";

  // Strip legacy keys; preserve everything else.
  const {
    clusterMinSize: _ignored1,
    clusterSensitivity: _ignored2,
    clusterGroupAllBelowZoom: _ignored3,
    clusterDisableAboveZoom: _ignored4,
    ...rest
  } = stored ?? {};

  return { ...rest, clusterPreset: preset };
}
